export default __webpack_public_path__ + "static/media/Group_7471.3119f8a8.png";